module.exports = __webpack_public_path__ + "static/media/quote-mandela-lastspeak-fr.cbab1f7b.png";